import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    Typography,
    IconButton,
    ListItemIcon,
    Paper
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CloseIcon from "@mui/icons-material/Close";

export default function Notifications({ open, handleClose, initialNotifications = [] }) {
    const [notifications, setNotifications] = useState(initialNotifications);
    const navigate = useNavigate();

    // 🔑 synchronizacja z props
    useEffect(() => {
        setNotifications(initialNotifications);
    }, [initialNotifications]);

    const renderMessage = (n) => {
        if (n.message && n.message.includes("Szczegóły w zakładce Blokady")) {
            const index = n.message.lastIndexOf("Blokady");
            const before = n.message.substring(0, index);
            const after = n.message.substring(index + "Blokady".length);
            return (
                <span>
                    {before}
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/SalaryBlocks");
                            handleClose();
                        }}
                        style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        Blokady
                    </a>
                    {after}
                </span>
            );
        }
        if (n.message && n.message.includes("Szczegóły w zakładce Prace dodatkowe")) {
            const index = n.message.lastIndexOf("Prace dodatkowe");
            const before = n.message.substring(0, index);
            const after = n.message.substring(index + "Prace dodatkowe".length);
            return (
                <span>
                    {before}
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/AdditionalCosts");
                            handleClose();
                        }}
                        style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        Prace dodatkowe
                    </a>
                    {after}
                </span>
            );
        }
        if (n.message && n.message.includes("Szczegóły w zakładce Sprawozdania Finansowe")) {
            const linkText = "Sprawozdania Finansowe";
            const index = n.message.lastIndexOf(linkText);
            const before = n.message.substring(0, index);
            const after = n.message.substring(index + linkText.length);
            return (
                <span>
                    {before}
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/FinancialStatements");
                            handleClose();
                        }}
                        style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        {linkText}
                    </a>
                    {after}
                </span>
            );
        }
        return n.message;
    };


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: 6,
                },
            }}
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                Powiadomienia
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {notifications.length === 0 ? (
                    <Typography color="text.secondary" align="center">
                        Brak nowych powiadomień
                    </Typography>
                ) : (
                    <List sx={{ maxHeight: 300, overflowY: "auto" }}>
                        {notifications.map((n, index) => (
                            <ListItem
                                key={index}
                                sx={{
                                    mb: 1,
                                    borderRadius: 2,
                                    boxShadow: 1,
                                }}
                            >
                                <ListItemIcon>
                                    <NotificationsIcon color={n.isPendingApproval ? "primary" : "warning"} />
                                </ListItemIcon>
                                <ListItemText primary={renderMessage(n)} />
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} variant="contained" color="primary">
                    Zamknij
                </Button>
            </DialogActions>
        </Dialog>
    );
}
